<template>
  <div class="signature-list">
    <div v-if="!signatures.length" class="text-center text-disabled py-6">
      Підписи відсутні
    </div>

    <div
      v-for="signature in signatures"
      :key="signature.id || signature.documentSigned"
      class="signature-card">
      <div class="font-weight-bold d-flex align-center gap-1">
        <v-icon color="success" size="small">mdi-check</v-icon>
        <span class="text-success">Підписано</span>
      </div>

      <div class="font-weight-bold mt-3">
        {{ getOrganization(signature) }}
      </div>
      <div v-if="getCode(signature)" class="text-disabled">
        {{ getCode(signature) }}
      </div>
      <div class="text-disabled mt-2">
        {{ new CustomDate(signature.signingDate).toString({ time: true }) }}
      </div>
      <div class="text-disabled mb-3">
        {{
          signature.fullCertificate.certificateInfo.extKeyUsages
            ? 'Електронна печатка'
            : 'Електронний підпис'
        }}
      </div>

      <signature-info-value
        title="Власник ключа"
        :value="
          signature.fullCertificate.certificateInfo.subjFullName ||
          signature.fullCertificate.certificateInfo.subjCN
        "></signature-info-value>
      <signature-info-value
        title="АЦСК"
        :value="
          signature.fullCertificate.certificateInfo.issuerCN
        "></signature-info-value>
      <signature-info-value
        title="Організація (установа)"
        :value="getOrganization(signature)"></signature-info-value>
      <signature-info-value
        title="Посада"
        :value="
          signature.fullCertificate.certificateInfo.subjTitle
        "></signature-info-value>
      <signature-info-value
        title="Серійний номер"
        :value="
          signature.fullCertificate.certificateInfo.serial
        "></signature-info-value>
    </div>

    <v-divider v-if="signatures.length" class="mt-4 mb-4"></v-divider>

    <div class="d-flex justify-end">
      <v-btn border color="white" @click="dialog.close()">
        Закрити
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, PropType } from 'vue'
import { Dialog } from '@/dialog'
import SignatureInfoValue from '@/components/signature/SignatureInfoValue.vue'
import { CustomDate } from 'best-modules/utils'
import { DocumentRouteSignature } from '@/utils/types/document'

export default {
  name: 'DocumentRouteSignatures',
  components: { SignatureInfoValue },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { CustomDate },
  setup(props) {
    const signatures = computed<DocumentRouteSignature[]>(() => {
      return props.dialog.dialogData.signatures || []
    })

    const getOrganization = (signature: DocumentRouteSignature) => {
      const certificate = signature.fullCertificate.certificateInfo

      if (certificate.issuerCN?.includes('DIIA')) {
        return certificate.subjOrg || certificate.subjCN || 'ФІЗИЧНА ОСОБА'
      }

      return (
        certificate.subjOrg ||
        certificate.organization ||
        certificate.subjCN ||
        'ФІЗИЧНА ОСОБА'
      )
    }

    const getCode = (signature: DocumentRouteSignature) => {
      return (
        signature.fullCertificate.certificateInfo.subjEDRPOUCode ||
        signature.fullCertificate.certificateInfo.subjDRFOCode
      )
    }

    return { signatures, getOrganization, getCode }
  },
}
</script>

<style scoped lang="scss">
.signature-list {
  max-height: 70vh;
  overflow-y: auto;
}

.signature-card {
  padding: 16px 20px;
  border-left: 4px solid rgb(var(--v-theme-success));
  background: rgb(var(--v-theme-grey-lighten-5));

  & + & {
    margin-top: 14px;
  }
}
</style>
